import { mapTrackObject } from "../tracks/map";
var isPlaylistEntryObject = function (object) {
    return "source_playlist_id" in object && object.source_playlist_id !== null;
};
export var mapTimetableDetailObject = function (object) { return ({
    id: object.id,
    title: object.title,
    entries: object.rules.map(function (entry) {
        if (!isPlaylistEntryObject(entry)) {
            return {
                id: entry.id,
                type: "track",
                playOrder: "single",
                trackId: entry.track_id,
                track: entry.track ? mapTrackObject(entry.track) : null,
            };
        }
        return {
            id: entry.id,
            type: "playlist",
            playlistId: entry.source_playlist_id,
            playOrder: entry.play_order,
            duration: entry.duration,
            trackCount: entry.n_tracks,
        };
    }),
}); };
